import { bindEvent } from "./events.js";
import { bindHelpHover, cancelHelpHover } from "./help-hover.js";
export function bindHelpPreview(details, summary, state, setOpen, delayMs = 120) {
    const sync = (current) => setOpen(current, state.pinned || (!state.suppressed && (state.hovered || state.focused)));
    bindHelpHover(summary, state, sync, delayMs);
    bindEvent(details, "pointerleave", (event) => {
        if (event.pointerType !== "mouse")
            return;
        cancelHelpHover(state);
        state.hovered = false;
        sync(event.currentTarget);
    });
    bindEvent(details, "pointerdown", () => {
        cancelHelpHover(state);
        state.pointerFocus = true;
    });
    bindEvent(details, "focusin", (event) => {
        const current = event.currentTarget;
        if (!current.contains(event.relatedTarget) && !state.pointerFocus) {
            cancelHelpHover(state);
            state.focused = true;
            state.anchor = undefined;
            state.suppressed = false;
            sync(current);
        }
        state.pointerFocus = false;
    });
    bindEvent(details, "focusout", (event) => {
        const current = event.currentTarget;
        if (current.contains(event.relatedTarget))
            return;
        state.focused = false;
        state.pointerFocus = false;
        sync(current);
    });
    bindEvent(details, "click", (event) => {
        const current = event.currentTarget;
        if (!current.querySelector("summary")?.contains(event.target))
            return;
        event.preventDefault();
        cancelHelpHover(state);
        state.pinned = !state.pinned;
        state.suppressed = !state.pinned;
        state.pointerFocus = false;
        sync(current);
    });
    bindEvent(details, "keydown", (event) => {
        const current = event.currentTarget;
        if (event.key !== "Escape" || !current.open)
            return;
        event.preventDefault();
        cancelHelpHover(state);
        // Focus first: returning from a link must not undo Escape's suppression.
        current.querySelector("summary")?.focus({ preventScroll: true });
        state.pinned = false;
        state.suppressed = true;
        sync(current);
    });
}
//# sourceMappingURL=help-preview.js.map